<script setup lang="ts">
import { Field as FormField } from "vee-validate";
import FormItem from "./FormItem.vue";
import FormMessage from "./FormMessage.vue";
</script>

<template>
  <FormField v-slot="{ errorMessage }" name="server">
    <FormItem v-if="errorMessage" class="mt-4">
      <FormMessage />
    </FormItem>
  </FormField>
</template>
